import React from 'react';
import { Input, Button, Select, Table } from 'components';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, checkPermission, Colors } from 'utils';
import { ReferralService } from 'services';
import moment from 'moment';

interface Props {
	onClose?: any;
	item?: any;
	referral_amounts?: any;
}

class ModalView extends React.Component<Props> {

	state = {
		referral: null
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await ReferralService.admin.view({
			referral_id: this.props.item?.id
		});
		this.setState({
			referral: res.referral
		});
	}

	pay = () => {
		Globals.confirm('¿Realizar el pago del bono?',async () => {
			await ReferralService.admin.pay({
				referral_id: this.props.item?.id
			});
			Globals.showSuccess("Se ha realizado el pago correctamente");
			this.props.onClose();
		});
	}

	getColor = (status: number) => {
		switch(status) {
			case Constants.REFERRAL_STATUS.PENDING:
				return Colors.yellow;
			break;

			case Constants.REFERRAL_STATUS.FINISH:
				return Colors.danger;
			break;

			case Constants.REFERRAL_STATUS.PAID:
				return Colors.green;
			break;
		}
	}
	
	render() {
		const referral: any = this.state.referral;
		const referral_amount = this.props.referral_amounts?.find((i: any) => i.country_id == referral?.user?.country_id);

		return (
			<div id="modal-referral-view">
				{
					referral != null && (
						<>
							<div className="row">
								<div className="col-md-6">
									<p className="name"><strong>{ referral?.user ? (referral?.user?.name + ' ' + referral?.user?.lastname) : '-' }</strong></p>
									<p className="email">{ referral?.user ? referral?.user?.email : '-' }</p>
									<p style={{ whiteSpace: 'nowrap' }}>{ ((referral?.user?.document_type?.name || '') + ((referral?.user?.document_type_id == Constants.DOCUMENT_TYPES.PASSPORT || referral?.user?.document_type_id == Constants.DOCUMENT_TYPES.COLOMBIA) ? ' - ' : '')) + referral?.user?.document }</p>
								</div>
								<div className="col-md-6 text-right">
									<p className="amount"><strong>Fecha de pago:</strong> { referral?.payment_date ? moment(referral?.payment_date).format('DD/MM/YYYY') : '-' }</p>
									<p className="amount"><strong>Monto { referral?.status == Constants.REFERRAL_STATUS.PAID ? 'pagado' : 'a pagar' }:</strong> { referral?.status == Constants.REFERRAL_STATUS.PENDING ? '-' : referral?.status == Constants.REFERRAL_STATUS.FINISH ? Globals.formatMiles(referral_amount?.amount) : Globals.formatMiles(referral?.amount) }</p>
									<p className="status"><strong>Estatus pago de bono:</strong> <span style={{ color: this.getColor(referral?.status) }}>{ referral?.status_text }</span></p>
									{
										referral?.status == Constants.REFERRAL_STATUS.FINISH && referral?.user?.country_id == Constants.COUNTRIES.VZLA && (
											<Button type="submit" className="btn-save" onClick={ () => this.pay() }>
												Pagar Bono
											</Button>
										)
									}
								</div>
							</div>
								
							<Table data={ referral?.users?.length } header={ ['Usuario','Fecha de Registro','Fecha de Pago','Nº San'] }>
								{
									referral?.users?.map((item: any) => {
										return (
											<tr>
												<td>
													<p className="name"><strong>{ item?.user ? (item?.user?.name + ' ' + item?.user?.lastname) : '-' }</strong></p>
													<p className="email">{ item?.user ? item?.user?.email : '-' }</p>
													<p style={{ whiteSpace: 'nowrap' }}>{ ((item?.user?.document_type?.name || '') + ((item?.user?.document_type_id == Constants.DOCUMENT_TYPES.PASSPORT || item?.user?.document_type_id == Constants.DOCUMENT_TYPES.COLOMBIA) ? ' - ' : '')) + item?.user?.document }</p>
												</td>
												<td>{ moment(item?.user?.created_at).format('DD/MM/YYYY HH:mm') }</td>
												<td>{ moment(item?.created_at).format('DD/MM/YYYY HH:mm') }</td>
												<td>{ item?.payment?.san?.code || '-' }</td>
											</tr>
										)
									})
								}
							</Table>
						</>
					)
				}
			</div>
		)
	}
}

export default ModalView;